import { render, staticRenderFns } from "./GroupsDetailPage.vue?vue&type=template&id=4174d8c0&scoped=true&"
import script from "./GroupsDetailPage.vue?vue&type=script&lang=js&"
export * from "./GroupsDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./GroupsDetailPage.vue?vue&type=style&index=0&id=4174d8c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4174d8c0",
  null
  
)

export default component.exports